
import React from 'react';

export const WhatsAppFloat: React.FC = () => {
  const handleClick = () => {
    window.open('https://wa.me/554888397243?text=Olá vim do site e gostaria de atendimento', '_blank');
  };

  return (
    <div className="fixed bottom-6 right-6 z-50">
      <button
        onClick={handleClick}
        className="bg-[#25D366] hover:bg-[#20BA5A] text-white rounded-full p-4 shadow-2xl transition-all duration-300 hover:scale-110 group cursor-pointer whitespace-nowrap relative"
        aria-label="Falar no WhatsApp"
      >
        <i className="ri-whatsapp-fill text-2xl"></i>
        
        {/* Tooltip */}
        <div className="absolute right-full mr-3 top-1/2 transform -translate-y-1/2 bg-[#0D0D0D] text-white px-3 py-2 rounded-lg text-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap border border-[#C8A45D]">
          Fale conosco agora!
          <div className="absolute left-full top-1/2 transform -translate-y-1/2 border-4 border-transparent border-l-[#0D0D0D]"></div>
        </div>
      </button>
      
      {/* Pulse animation */}
      <div className="absolute inset-0 bg-[#25D366] rounded-full animate-ping opacity-20 pointer-events-none"></div>
    </div>
  );
};

export default WhatsAppFloat;
